/**
 * Hook for transit selection state management.
 */
import { useState, useMemo } from 'react';
import { computeOverlapMap } from '../utils/overlapDetection';

export const useTransitSelection = ({ transits, baselineBefore, baselineAfter }) => {
  const [selectedTransits, setSelectedTransits] = useState(new Set());

  const handleSelectTransit = (transitId) => {
    const newSelected = new Set(selectedTransits);
    if (newSelected.has(transitId)) {
      newSelected.delete(transitId);
    } else {
      newSelected.add(transitId);
    }
    setSelectedTransits(newSelected);
  };

  const handleSelectAll = () => {
    if (selectedTransits.size === transits.length) {
      setSelectedTransits(new Set());
    } else {
      const allIds = transits.map(t =>
        `${t.exoplanet.name}_${new Date(t.transit.time_utc).getTime()}`
      );
      setSelectedTransits(new Set(allIds));
    }
  };

  const overlapMap = useMemo(
    () => computeOverlapMap(transits, selectedTransits, baselineBefore, baselineAfter),
    [transits, selectedTransits, baselineBefore, baselineAfter]
  );

  return {
    selectedTransits,
    setSelectedTransits,
    handleSelectTransit,
    handleSelectAll,
    overlapMap,
  };
};
